import { flattenTemplates as _flattenTemplates } from '@takeshape/schema';
import { weakMemoize } from '@takeshape/util';

export const flattenTemplates = weakMemoize(_flattenTemplates);
